import Img from "components/atoms/Img";
import Title from "components/atoms/Title";

/*** Vendors ***/

/*** components ***/

/*** ========== ***/

/**
 *
 * @param {{
 * }} props Props for the component
 *
 */
const IntroduceShowMore = ({ data }) => {
  return (
    <>
      <Title
        as="h2"
        othersClass="mb-6 lg:mb-10 lg:text-center"
        title={
          typeof data.title === "string"
            ? {
                content: data?.title || "Các gói dịch vụ",
              }
            : { ...data.title }
        }
      />

      <div className="row">
        {data.product_list.map((item, index) => (
          <div
            className={`lg:col-6 ${
              (index < data.product_list.length - 2 && "mb-4 lg:mb-10") ||
              "mb-4 last:mb-0 lg:mb-0"
            }`}
            key={index}
          >
            <div className="flex h-full flex-col justify-start">
              <Img
                src={item.img_src}
                width={item.width || 540}
                height={item.height || 350}
                className=" h-full w-full  object-cover object-center "
                wrapper={{
                  className: " mb-4 rounded-xl overflow-hidden  w-full",
                }}
              />
              <div className="text-center">
                <p className="mb-0 text-left">
                  {item.name && (
                    <span
                      dangerouslySetInnerHTML={{ __html: item.name }}
                    ></span>
                  )}
                  {item.prefix && <span>{item.prefix}</span>}
                  {item.fee && (
                    <span>
                      {item.fee.toLocaleString("en-US", {
                        style: "currency",
                        currency: "VND",
                      })}
                    </span>
                  )}
                  {item.des && (
                    <p dangerouslySetInnerHTML={{ __html: item.des }}></p>
                  )}
                </p>
                {/* <Button
                  as="a"
                  variant="outline"
                  btnTextColor="text-gleads-buttonBlue-600 hover:text-white"
                  href={item.contact_link}
                >
                  Liên hệ
                </Button> */}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default IntroduceShowMore;
